import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateTime } from 'luxon';

@Component({
	selector: 'contact-severity-chart',
	templateUrl: './contact-severity-chart.component.html',
	styleUrls: ['./contact-severity-chart.component.scss'],
})
export class ContactSeverityChartComponent implements OnInit {
	constructor(public translateService: TranslateService) {}
	@Input() type: 'CGI' | 'LIFE_QUALITY';

	_severityResults: any[] = [];

	@Input() set severityResults(value) {
		this._severityResults = value.reverse().map((result, i) => {
			return {
				...result,
				sessionNumber: i + 2,
				level: this.reverseLevel(result.level),
			};
		});

		this.setPaginationData();
	}

	@Output() goToPromptuaries = new EventEmitter<void>();

	currentPage = 1;
	totalPages = null;
	paginatedSeverityResults: any[];
	tooltipLabel;
	chartOptions;
	chartData;

	ngOnInit(): void {
		this.tooltipLabel = this.translateService.instant(
			this.type === 'CGI'
				? 'CONTACT.CGI-CHART_TOOLTIP'
				: 'CONTACT.LIFE_QUALITY-CHART_TOOLTIP'
		);
	}

	changePage(control: 'next' | 'previous' | null) {
		if (control) {
			this.currentPage =
				control === 'next' ? this.currentPage + 1 : this.currentPage - 1;
		}
		this.setPaginatedSeverityResults();
		this.setChartData();
		this.setChartOptions();
	}

	setPaginatedSeverityResults() {
		const start = (this.currentPage - 1) * 9;
		const end = this.currentPage * 9;
		this.paginatedSeverityResults = this._severityResults.slice(start, end);
	}

	setPaginationData() {
		this.totalPages = Math.ceil(this._severityResults.length / 9);
		this.currentPage = this.totalPages;
		this.changePage(null);
	}

	setChartData() {
		this.chartData = {
			labels: this.paginatedSeverityResults?.map(
				(result) => result.sessionNumber + 'º'
			),
			datasets: [
				{
					data: this.paginatedSeverityResults?.map((result) => result.level),
					fill: false,
					borderColor: '#6732D1',
					lineTension: 0.3,
				},
			],
		};
	}

	setChartOptions() {
		this.chartOptions = {
			elements: {
				point: {
					borderWidth: 2,
					backgroundColor: 'white',
				},
			},
			plugins: {
				legend: {
					display: false,
				},
				tooltip: {
					displayColors: false,
					callbacks: {
						title: function (context) {
							return 'Data: ' + this.formatDate(context[0].dataIndex);
						}.bind(this),
						afterTitle: function (context) {
							return (
								'Motivos: ' +
								this.paginatedSeverityResults[
									context[0].dataIndex
								].reasons.join(', ')
							);
						}.bind(this),
						label: function () {
							return '';
						},
					},
				},
			},
			scales: {
				x: {
					border: false,
					grid: {
						display: false,
					},
				},
				y: {
					grid: {
						borderWidth: 0,
					},
					min: 0,
					max: 7,
					ticks: {
						color: '#6732D1',
						callback: function (value) {
							return this.translateService.instant(
								'CONTACT.SEVERITY.' + this.type + '.' + this.reverseLevel(value)
							);
						}.bind(this),
					},
				},
			},
		};
	}

	formatDate(index) {
		const date = this.paginatedSeverityResults[index].registerDate;
		return DateTime.fromISO(date).toFormat('dd/MM/yyyy');
	}

	reverseLevel(level) {
		// Invertemos o level, para que o level 1 apareceça no index 7 do eixo Y
		// Assim o level 1 'Muito melhor' aparece no topo do gráfico
		const reversedLevels = {
			0: 0,
			1: 7,
			2: 6,
			3: 5,
			4: 4,
			5: 3,
			6: 2,
			7: 1,
		};
		return reversedLevels[level];
	}
}
